import type { ChatMessage, UserMessage } from '../hooks/use-chat-ws';

const REQUEST_INTERRUPTED_BY_USER = '[Request interrupted by user]';

export const isQuestionAnswerMessage = (m: ChatMessage): m is UserMessage & { question_id: string } =>
  m.type === 'user' && !!m.question_id;

export const latestUnansweredQuestionId = (messages: ChatMessage[]): string | undefined => {
  const answeredIds = new Set(messages.filter(isQuestionAnswerMessage).map(m => m.question_id));
  for (let i = messages.length - 1; i >= 0; i--) {
    const msg = messages[i];
    if (msg.type === 'user' && msg.question_id) continue;
    if (msg.type === 'user' && msg.content === REQUEST_INTERRUPTED_BY_USER) continue;
    if (msg.type === 'user') return undefined;
    if (msg.type === 'tool_use' && msg.tool === 'AskUserQuestion') {
      return answeredIds.has(msg.id) ? undefined : msg.id;
    }
  }
  return undefined;
};
